<div mat-dialog-content>
    <div fxLayoutAlign="center center">
        <p>
            {{message}}
        </p>
    </div>
  </div>
  
  
  <div *ngIf="buttons && buttons.length > 0" mat-dialog-actions fxLayoutAlign="space-around" class="p-3">
       <button *ngFor="let btn of buttons"
       mat-raised-button 
       [color]="btn.color || null" 
       [style.width]="btn.width || 'auto'" 
       (click)="onClick(btn)">{{btn.text}}</button>


    <!-- <button mat-raised-button color="accent" style="width: 40%" (click)="onSend()">{{'SEND' | translate}}</button>
    <button mat-raised-button [mat-dialog-close] style="width: 40%" cdkFocusInitial>{{'CANCEL' | translate}}</button> -->
  </div>
